import { useReducer } from 'react';
function useToggle(initialValue = false, options) {
    const { onChange, onClose, onOpen } = options !== null && options !== void 0 ? options : {};
    const reducer = (state, newValue) => {
        const value = typeof newValue === 'boolean' ? newValue : !state;
        if (value)
            onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        else
            onClose === null || onClose === void 0 ? void 0 : onClose();
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
        return value;
    };
    return useReducer(reducer, initialValue);
}
export default useToggle;
//# sourceMappingURL=use-toggle.js.map